import React, { FC, useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import { connect, ConnectedProps } from 'react-redux';
import { addOrgVideoCountWatch } from 'redux/organization-service/actions';
import Loader from '../Loader';
import styles from './VideoPreviewSquare.module.scss';

type VideoPreviewSquareParentProps = {
	parrentClassName?: string;
	link: string;
	setVideoTime?: React.Dispatch<React.SetStateAction<number>>;
	videoId?: number;
	smallerActionButton?: boolean;
};
const VideoPreviewSquare: FC<VideoPreviewSquareProps> = ({
	parrentClassName,
	link,
	setVideoTime,
	videoId,
	countWatch,
	smallerActionButton = false,
}: VideoPreviewSquareProps) => {
	const [isShowPlayButton, setIsShowPlayButton] = useState(true);
	const [isLoading, setIsLoading] = useState(false);
	const videoRef = useRef<HTMLVideoElement>(null);

	const videoClickHandler = () => {
		if (videoRef.current) {
			if (videoRef.current.paused) {
				videoRef.current.play();
				setIsShowPlayButton(false);
				if (videoId) countWatch(videoId);
			} else {
				videoRef.current.pause();
				setIsShowPlayButton(true);
			}
		}
	};

	useEffect(() => {
		if (videoRef.current && setVideoTime) {
			videoRef.current.onloadstart = () => setIsLoading(true);

			videoRef.current.onloadedmetadata = () => {
				const duration = videoRef.current?.duration;
				if (duration) setVideoTime(duration);
				setIsLoading(false);
			};
		}
	}, [videoRef.current, isLoading]);

	return (
		<div className={cx(parrentClassName && parrentClassName, styles.video__wrapper)}>
			{isLoading && <Loader loadProps={{ stylePageCenter: true }} />}
			<video className={styles.player} ref={videoRef} onClick={videoClickHandler} muted={true} src={link} />
			{isShowPlayButton && !isLoading && (
				<div
					onClick={videoClickHandler}
					className={smallerActionButton ? styles.smaller : styles.video__actionButton}
				/>
			)}
		</div>
	);
};

const mapDispatchToProps = {
	countWatch: addOrgVideoCountWatch,
};

const connector = connect(null, mapDispatchToProps);
type VideoPreviewSquareProps = ConnectedProps<typeof connector> & VideoPreviewSquareParentProps;

export default connector(VideoPreviewSquare);
